function onlyUnique<T>(value: T, index: number, array: T[]) {
  return array.indexOf(value) === index
}

export function getDistinct<T>(array: T[]): T[] {
  return array.filter(onlyUnique)
}

export function sortResultNumber(a: number, b: number): number {
  return a !== b ? (a < b ? -1 : 1) : 0
}
export function sortResultString(a: string, b: string): number {
  return (a ?? '').localeCompare(b ?? '')
}
